/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument } from './HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument';
import {
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSON,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSONTyped,
    HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSON,
} from './HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument';

/**
 * 
 * @export
 * @interface HchbPatientDetailsDocumentsAdditionalDocumentsInner
 */
export interface HchbPatientDetailsDocumentsAdditionalDocumentsInner {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    lead_id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    s3_key: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    content_type?: string;
    /**
     * 
     * @type {number}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    filesize_in_bytes?: number;
    /**
     * 
     * @type {number}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    page_count?: number;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    s3_access_url?: string;
    /**
     * 
     * @type {HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    external_ehr_document?: HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocument;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsDocumentsAdditionalDocumentsInner
     */
    combined_from_lead_id?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsDocumentsAdditionalDocumentsInner interface.
 */
export function instanceOfHchbPatientDetailsDocumentsAdditionalDocumentsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "s3_key" in value;

    return isInstance;
}

export function HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSON(json: any): HchbPatientDetailsDocumentsAdditionalDocumentsInner {
    return HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSONTyped(json, false);
}

export function HchbPatientDetailsDocumentsAdditionalDocumentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsDocumentsAdditionalDocumentsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lead_id': !exists(json, 'lead_id') ? undefined : json['lead_id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        's3_key': json['s3_key'],
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'content_type': !exists(json, 'content_type') ? undefined : json['content_type'],
        'filesize_in_bytes': !exists(json, 'filesize_in_bytes') ? undefined : json['filesize_in_bytes'],
        'page_count': !exists(json, 'page_count') ? undefined : json['page_count'],
        's3_access_url': !exists(json, 's3_access_url') ? undefined : json['s3_access_url'],
        'external_ehr_document': !exists(json, 'external_ehr_document') ? undefined : HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentFromJSON(json['external_ehr_document']),
        'combined_from_lead_id': !exists(json, 'combined_from_lead_id') ? undefined : json['combined_from_lead_id'],
    };
}

export function HchbPatientDetailsDocumentsAdditionalDocumentsInnerToJSON(value?: HchbPatientDetailsDocumentsAdditionalDocumentsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lead_id': value.lead_id,
        'name': value.name,
        's3_key': value.s3_key,
        'created_at': value.created_at,
        'content_type': value.content_type,
        'filesize_in_bytes': value.filesize_in_bytes,
        'page_count': value.page_count,
        's3_access_url': value.s3_access_url,
        'external_ehr_document': HchbPatientDetailsDocumentsGeneratedDocumentsInnerExternalEhrDocumentToJSON(value.external_ehr_document),
        'combined_from_lead_id': value.combined_from_lead_id,
    };
}

